import React, {
  useCallback,
  useRef,
  useState,
  useMemo,
  useEffect,
} from "react";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-enterprise";

import axios from "axios";
import {
  agGridOptionsSingle,
  agGridTheme,
  HOST_URL,
} from "../../helpers/constants/Constants";
import CustomFormRenderComp from "./CustomFormRenderComp";
import createMultiSelect from "../ag-grid/createMultiSelect";
import {
  addChecklist,
  updateChecklist,
} from "../../helpers/axios/checklistsAxios";
import * as _ from "lodash";
import Modal from "react-bootstrap/Modal";

//Checklist Admin Page
const CheckLists = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [addChecklistInput, setAddChecklistInput] = useState(false);

  //Local Component
  const gridButton = (props) => {
    return (
      <button
        className="btn btn-primary btn-sm mb-2"
        onClick={(e) => setSelectedChecklistId(props.value)}
      >
        View
      </button>
    );
  };
  //----------------------

  //Local Variables
  const columnDefsOg = [
    { field: "id", cellRenderer: gridButton, width: 50, headerName: "ID" },
    { field: "name" },
    {
      field: "keys",
      valueGetter: (params) => {
        if (params.data.keys === null) return [];
        return params.data.keys;
      },
      cellEditor: createMultiSelect,
      cellEditorPopup: true,
      editable: true,
      singleClickEdit: true,
      cellEditorParams: (row) => {
        return {
          values: row.data.keys?.map((role) => {
            return role.role;
          }),
        };
      },
      onCellValueChanged: (data) => {
        updateChecklist(data.data);
      },
    },

    // { field: "status" },
    // { field: "type" },
  ];

  //State
  const [selectedChecklistId, setSelectedChecklistId] = useState(null);
  const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [checklists, setChecklists] = useState([]);
  const [editMode, setEditMode] = useState(false);
  //-------------------------

  const gridRef = useRef(null);
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      filter: "agSetColumnFilter",
    };
  }, []);
  //------------------------

  //Use Effect
  useEffect(() => {
    loadChecklists();
  }, []);

  const loadChecklist = useCallback(() => {
    axios
      .get(HOST_URL + "/checklists/get", {
        withCredentials: true,
        params: {
          id: selectedChecklistId,
        },
      })
      .then((response) => {
        setSelectedChecklist(response.data);
      })
      .catch(console.log);
  }, [selectedChecklistId]);

  useEffect(() => {
    if (selectedChecklistId !== null) {
      loadChecklist();
    } else {
      setSelectedChecklist(null);
    }
  }, [loadChecklist, selectedChecklistId]);
  //------------------------

  //Functions
  const loadChecklists = () => {
    axios
      .get(HOST_URL + "/checklists/getAll", {
        withCredentials: true,
      })
      .then((response) => {
        setChecklists(response.data);
        // setSelectedChecklistId(response.data[0].id);
      })
      .catch(console.log);
  };

  const resetIndex = async (data) => {
    var index = 1;

    await data
      .sort((a, b) => (a.index > b.index ? 1 : -1))
      .forEach(async (row) => {
        row.index = index;
        index = index + 1;
      });
    return data;
  };

  const updateIndex = async (type, item, value) => {
    var tempChecklist = selectedChecklist;
    switch (type) {
      case "Input":
        var tempGroup = tempChecklist.groups.find(
          (o) => o.id === item.checklistGroupId,
        );
        //If the row is negative or exceeds the length of the array, do nothing
        if (
          item.index + value <= 0 ||
          item.index + value >= tempGroup.rows.length + 1
        ) {
          return;
        }

        //Find the row in the desired spot and do the reverse
        tempGroup.rows.find((o) => o.index === item.index + value).index -=
          value;
        //Find the row and update its value
        tempGroup.rows.find((o) => o.id === item.id).index += value;
        //updateState
        setSelectedChecklist({ ...tempChecklist });
        break;
      case "Group":
        //If the group is negative or exceeds the length of the array, do nothing
        if (
          item.index + value <= 0 ||
          item.index + value >= tempChecklist.groups.length + 1
        ) {
          return;
        }

        //Find the group in the desired spot and do the reverse
        tempChecklist.groups.find(
          (o) => o.index === item.index + value,
        ).index -= value;
        //Find the group and update its value
        tempChecklist.groups.find((o) => o.id === item.id).index += value;
        //updateState
        setSelectedChecklist({ ...tempChecklist });
        break;
      default:
        break;
    }
  };
  const updateType = async (row, value) => {
    var tempChecklist = selectedChecklist;
    var tempGroup = tempChecklist.groups.find(
      (o) => o.id === row.checklistGroupId,
    );
    tempGroup.rows.find((o) => o.id === row.id).type = value;
    setSelectedChecklist({ ...tempChecklist });
  };
  const updateTitle = async (row, value) => {
    var tempChecklist = selectedChecklist;
    var tempGroup = tempChecklist.groups.find(
      (o) => o.id === row.checklistGroupId,
    );
    tempGroup.rows.find((o) => o.id === row.id).label = value;
    setSelectedChecklist({ ...tempChecklist });
  };

  const updateName = async (group, value) => {
    var tempChecklist = selectedChecklist;
    tempChecklist.groups.find((o) => o.id === group.id).name = value;
    setSelectedChecklist({ ...tempChecklist });
  };

  const removeRow = async (row) => {
    var tempChecklist = selectedChecklist;
    var tempGroup = tempChecklist.groups.find(
      (o) => o.id === row.checklistGroupId,
    );
    tempGroup.rows = tempGroup.rows.filter(function (r) {
      if (row.id !== null) {
        return r.id !== row.id;
      } else {
        return r.index !== row.index;
      }
    });
    tempGroup.rows = await resetIndex(tempGroup.rows);
    setSelectedChecklist({ ...tempChecklist });
  };

  const removeGroup = async (group) => {
    var tempChecklist = selectedChecklist;
    tempChecklist.groups = tempChecklist.groups.filter(function (g) {
      if (group.id !== null) {
        return g.id !== group.id;
      } else {
        return g.index !== group.index;
      }
    });
    tempChecklist.groups = await resetIndex(tempChecklist.groups);
    setSelectedChecklist({ ...tempChecklist });
  };

  const addInputToFormRows = (groupId, newInputRow) => {
    var tempNewInputRow = { ...newInputRow };
    tempNewInputRow.checklistGroupId = groupId;
    var tempChecklist = { ...selectedChecklist };
    var tempGroup = tempChecklist.groups.find((o) => o.id === groupId);

    //Add Options for Dropdown
    // if (tempNewInputRow.type === "Dropdown") {
    //   tempNewInputRow.options = selectOptionsValue;
    // }
    //Add index
    var maxIndex = tempGroup.rows
      .map((o) => o.index)
      .reduce((a, b) => Math.max(a, b), -Infinity);
    tempNewInputRow.index = maxIndex + 1;
    tempGroup.rows.push(tempNewInputRow);
    setSelectedChecklist({ ...tempChecklist });
  };

  const addNewGroup = () => {
    // Generate a new group object
    var tempChecklist = selectedChecklist;
    const newGroup = {
      id: _.uniqueId("group_"), // Generate a unique ID for the group
      name: "New Group",
      index: tempChecklist.groups.length + 1, // Set the index based on the current number of groups
      rows: [], // Initialize with no rows
      instructions: "", // Optional: Add instructions for the group
    };

    tempChecklist.groups.push(newGroup);
    setSelectedChecklist({ ...tempChecklist });
  };

  const saveGroupsAndRows = () => {
    var formData = new FormData();
    const data = {
      formGroups: selectedChecklist.groups,
    };
    formData.append("formData", JSON.stringify(data));
    axios({
      method: "post",
      url: HOST_URL + "/checklists/saveGroupsAndRows",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then((response) => {
        alert("Saved");
        //redirect back to the checklist page
        setSelectedChecklistId(null);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <Modal
        show={showAddModal}
        onHide={(e) => {
          setShowAddModal(false);
        }}
      >
        <Modal.Header>
          <Modal.Title>Confirm Add</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={(e) => {
                setShowAddModal(false);
              }}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* Recieve the input from the user for the modal name and keys */}
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Name
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="Enter Checklist Name"
              value={addChecklistInput?.name}
              onChange={(e) => {
                setAddChecklistInput({
                  ...addChecklistInput,
                  name: e.target.value,
                });
              }}
            />
          </div>
          {/* <div className="mb-3">
            <label htmlFor="keys" className="form-label">
              Keys
            </label>
            <CreatableSelect
              isMulti
              options={selectOptions}
              onChange={(e) => {
                // setSelectOptionsValue(e);
                setAddChecklistInput({ ...addChecklistInput, keys: e });
              }}
              onInputChange={(e) => {
                // setSelectOptionsInputValue(e);
                setAddChecklistInput({ ...addChecklistInput, selectOptionsInputValue: e });
              }}
              inputValue={selectOptionsInputValue}
              placeholder="Enter Keys"
            />
          </div> */}
          <div className="d-flex justify-content-end p-1">
            <button
              className="btn btn-secondary btn-sm"
              onClick={(e) => {
                setShowAddModal(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success btn-sm"
              onClick={(e) => {
                //Add the checklist to the database
                addChecklist(addChecklistInput)
                  .then((response) => {
                    setChecklists([...checklists, response.data]);
                    setShowAddModal(false);
                  })
                  .catch(console.log);
              }}
            >
              Add
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <h1 className="p-1">
        CheckLists{selectedChecklist !== null && " - " + selectedChecklist.name}
      </h1>
      <div className="d-flex justify-content-end p-1">
        <button
          className="btn btn-primary btn-sm mb-2"
          onClick={(e) => {
            setShowAddModal(true);
          }}
        >
          Add Checklist
        </button>
      </div>
      <div id="container" className="" style={{ height: "70VH" }}>
        {/* Grid */}
        {selectedChecklistId === null && (
          <div id="gridStyle" style={{ height: "70VH" }}>
            <AgGridReact
              theme={agGridTheme}
              ref={gridRef}
              rowData={checklists}
              columnDefs={columnDefsOg}
              defaultColDef={defaultColDef}
              gridOptions={agGridOptionsSingle}
            />
          </div>
        )}
        {selectedChecklist !== null && (
          <>
            <button
              className="btn btn-primary btn-sm mb-2"
              onClick={(e) => setSelectedChecklistId(null)}
            >
              Back
            </button>
            <button
              className="btn btn-primary btn-sm mb-2"
              onClick={(e) => {
                setEditMode(!editMode);
              }}
            >
              Edit
            </button>
            {/* {editMode === false && (
              <button className="btn btn-primary btn-sm mb-2" onClick={(e) => recordFormRows()}>
                Record
              </button>
            )} */}
            {editMode === true && (
              <button
                className="btn btn-primary btn-sm mb-2"
                onClick={(e) => saveGroupsAndRows()}
              >
                Save
              </button>
            )}

            {/* <CustomFormRenderComp
              rows={selectedChecklist.checklistRows}
              editMode={editMode}
              updateIndex={updateIndex}
              removeRow={removeRow}
              addInputToFormRows={addInputToFormRows}
            ></CustomFormRenderComp> */}
            <CustomFormRenderComp
              key={selectedChecklist.id}
              form={selectedChecklist}
              editMode={editMode}
              updateIndex={updateIndex}
              updateType={updateType}
              updateTitle={updateTitle}
              updateName={updateName}
              removeRow={removeRow}
              removeGroup={removeGroup}
              addInputToFormRows={addInputToFormRows}
              addNewGroup={addNewGroup}
            ></CustomFormRenderComp>

            {/* 
            {selectedChecklist.checklistGroups
              ?.sort((a, b) => (a.index > b.index ? 1 : -1))
              .map((group) => {
                return (
                  <>
                    <div className="mt-2 d-flex justify-content-center">
                      <div className="col-8">
                        <h3>{group.name}</h3>
                      </div>
                    </div>
                    <CustomFormRenderComp
                      checklist={selectedChecklist}
                      rows={group.rows}
                      editMode={editMode}
                      updateIndex={updateIndex}
                      removeRow={removeRow}
                      addInputToFormRows={addInputToFormRows}></CustomFormRenderComp>
                  </>
                );
              })} */}

            {/* {groupHeadings?.map((heading) => {
            return (
              <>
                <div className="mt-2 d-flex justify-content-center">
                  <div className="col-8">
                    <h3>{heading}</h3>
                  </div>
                </div>
                <CustomFormRenderComp rows={selectedChecklist.checklistRows.filter((o) => o.grouping === heading)} editMode={false}></CustomFormRenderComp>
              </>
            );
          })} */}
          </>
        )}
      </div>
    </>
  );
};

export default CheckLists;
